import axiosInstance from '../utils/AxiosConfig';

export const getRolesAndPermissions = async () => {
  try {
    const response = await axiosInstance.get('/roles');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching role:', error);
    throw new Error('Error fetching role');
  }
};

export const instantiateRoleTemplate = async (code, payload = {}) => {
  try {
    const response = await axiosInstance.post(`/roles/templates/${code}/instantiate`, payload);
    return response.data.data;
  } catch (error) {
    console.error('Error instantiating role template:', error);
    throw error;
  }
};

export const addRole = async (roleData) => {
  try {
    const response = await axiosInstance.post('/roles', roleData);
    return response.data.data;
  } catch (error) {
    console.error('Error adding role:', error);
    throw new Error('Error adding role');
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await axiosInstance.delete(`/roles/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error deleting role:', error);
    throw new Error('Error deleting role');
  }
};

export const editRole = async (id, roleData) => {
  try {
    const response = await axiosInstance.put(`/roles/${id}`, roleData);
    return response.data.data;
  } catch (error) {
    console.error('Error editing role:', error);
    throw new Error('Error editing role');
  }
};
